import { IWaterMeterModel } from "../Types/WaterMeterTypes";

/**
 * Fetches all water meter data for the user.
 * @param municipalKey string determing municipality.
 * @param token oidc access token.
 */
async function getWaterSewageData(
  municipalKey: string,
  token: string
): Promise<IWaterMeterModel[]> {
  const url = `${import.meta.env.VITE_DATA_API}/api/watersewage/water-meter/${municipalKey}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return await response.json();
}

export { getWaterSewageData };
